import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CustomerState } from "./customer.reducer";

export const selectCustomerState = createFeatureSelector<CustomerState>('customer');

export const selectAllCustomers = createSelector(
  selectCustomerState,
  (state) => state ? state.allCustomers : null
);

export const selectRegisteredCustomers = createSelector(
  selectCustomerState,
  (state) => state ? state.registeredCustomers : null
);

export const selectCustomer = createSelector(
  selectCustomerState,
  (state) => state ? state.customer : null
)

export const selectSelectedGatewayCustomer = createSelector(
  selectCustomerState,
  (state) => state ? state.selectedGatewayCustomer : null
);

export const selectSelectedCustomer = createSelector(
  selectCustomerState,
  (state) => state ? state.selectedCustomer : null
);

export const selectCustomerCurrentCoins = createSelector(
  selectCustomerState,
  (state) => state ? (state.customer as any)?.coinsCurrent : 0
)

export const selectCustomerTotalCoins = createSelector(
  selectCustomerState,
  (state) => state ? (state.customer as any)?.coinsTotal : 0
);

export const selectSelectedContact = createSelector(
  selectCustomerState,
  (state) => state ? state.selectedContact : null
);

export const selectEmployeesOfCustomer = createSelector(
  selectCustomerState,
  (state) => state ? state.employeesOfCustomer : null
);
